import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { IS_APP_CODEAC } from '../constants/env';
export class UserMenu extends Component {
    render() {
        const { browser, user, t } = this.props;
        if (!user.loggedIn && !user.authenticating) {
            return _jsx("ul", { className: clsx('menu menu--horizontal', IS_APP_CODEAC && 'menu--horizontal-codeac'), children: _jsx("li", { className: "menu__item", children: _jsxs(Link, { to: "/login", className: "btn btn-outline-primary btn-sm", title: t('login'), children: [_jsx(Icon, { name: "user" }), "  ", t('login')] }) }) });
        }
        const username = user.user?.username ?? '';
        return user.user && (_jsxs("ul", { className: clsx('menu menu--horizontal', IS_APP_CODEAC && 'menu--horizontal-codeac'), children: [!user || !user.user || !IS_APP_CODEAC ? null : (_jsx("li", { className: "menu__item", children: _jsx(Link, { to: "/velocity-report", className: "btn btn-link", title: t('velocityReport'), children: _jsx(Icon, { name: "user-chart" }) }) })), _jsx("li", { className: "menu__item", children: _jsxs(Link, { to: "/settings", className: "btn btn-link", children: [browser.lessThan.medium ? null : username, _jsx("img", { src: user.user.bitbucketAvatar ||
                                    user.user.gitlabAvatar ||
                                    'https://bitbucket.org/account/' + username + '/avatar/32/', className: clsx('rounded-circle', !browser.lessThan.medium && 'ml-3'), height: "32", alt: username })] }) }), _jsx("li", { className: "menu__item", children: _jsx(Link, { to: "/logout", className: "btn btn-link", title: t('sign.out'), children: _jsx(Icon, { name: "power-off", className: "" }) }) })] }));
    }
}
const mapStateToProps = (state) => ({
    browser: state.browser,
    user: state.user,
});
// const mapDispatchToProps = dispatch => ({
// });
export default connect(mapStateToProps /*, mapDispatchToProps*/)(withTranslation()(UserMenu));
